import { privateAxios } from 'services/api/privateAxios';

export const updateInventory = inventory =>
  privateAxios({
    method: 'post',
    url: '/driver/inventory',
    data: inventory,
  });
